import {useCallback} from "react";
import {useAuthenticatedFetch} from "./useAuthenticatedFetch";
import {useUser} from "../../context/UserContext";
import {useAuth} from "../../context/AuthProvider";


export const useAuthenticatedFetchWithWorkspace = () => {
    const authFetch = useAuthenticatedFetch();
    const {selectedWorkspace, loadingUserInfos} = useUser();
    const {keycloakInstance, isLoading: authLoading} = useAuth();

    const isLoading = authLoading || loadingUserInfos;
    const isAuthenticated = keycloakInstance?.authenticated ?? false;
    const hasWorkspace = !!selectedWorkspace?.volumeName;
    const isReady = !isLoading && isAuthenticated && hasWorkspace;
    const workspaceName = selectedWorkspace?.volumeName?.trim() ?? null;

    const authFetchWithWorkspace = useCallback(async (endpoint: string, options: RequestInit = {}) => {
        if (!isReady) {
            const errorMsg = !isAuthenticated 
                ? "User not authenticated." 
                : !hasWorkspace 
                ? "No workspace selected." 
                : "Authentication or workspace loading...";
            throw new Error(errorMsg);
        }

        const workspaceHeaders = {
            "x-workspace": workspaceName!,
        };

        const mergedOptions = {
            ...options,
            headers: {
                ...(options.headers as object),
                ...workspaceHeaders,
            }
        };

        return authFetch(endpoint, mergedOptions);
    }, [authFetch, workspaceName, isReady, isAuthenticated, hasWorkspace]);

    return { 
        authFetch: authFetchWithWorkspace, 
        isReady, 
        isLoading,
        workspaceId: workspaceName
    };
};
